import { Component, OnInit } from '@angular/core';
import { ButtonModule, ButtonStyle } from 'rcp-common-lib';
import { NgOptimizedImage } from '@angular/common';
import { AuthService } from '@services/auth/auth.service';
import { AccountServiceResponse } from '@core/generated/openapi';

@Component({
    selector: 'rcp-oup-aging-not-subscribed',
    imports: [ButtonModule, NgOptimizedImage],
    templateUrl: './aging-not-subscribed.component.html',
    styleUrl: './aging-not-subscribed.component.scss',
})
export class AgingNotSubscribedComponent implements OnInit {
    protected readonly ButtonStyle = ButtonStyle;
    accountAgingStatus: AccountServiceResponse.StatusEnum;

    constructor(private authService: AuthService) {}

    ngOnInit() {
        this.accountAgingStatus = this.authService
            .getCurrentUser()
            .getValue()
            .accountModules?.find(
                (svc) =>
                    svc.serviceType ===
                    AccountServiceResponse.ServiceTypeEnum.AgingClaims,
            )?.status;
    }

    openLearnMore() {
        const url =
            'https://www.onespotbilling.com/insurance-ar-manager-for-improved-AR';
        window.open(url, '_blank');
    }

    openScheduleTour() {
        const url =
            'https://outlook.office365.com/book/OnespotSales@revcycle-partners.com/';
        window.open(url, '_blank');
    }
}
